module.exports = __webpack_public_path__ + "media/images/project/dependencies-ff9a40394b192ca2bbbda69b5aea3db9.svg";